import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import { MIcon, Flex, Button, Text, Line, Hr, Preloader0, Preloader } from './Uikit';
import { CSSgrid } from "./Catalog";
import { Appearer } from "./Appearer";
import uniqid from "uniqid";
import { Product } from "./Product";
import { StackInfo } from "./StackInfo";
import { getDataById, getDataByCode, codeHashToCopy } from './Utilities';
import { MetaContext } from "../context";
import { Svg } from "./Uikit_Svg";
import { useToasts } from "react-toast-notifications";
import { StackName } from "./StackName";

import emojiRegex from "emoji-regex/RGI_Emoji.js";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { indexOf } from "lodash";
import { AddToCart } from "./AddToCart";





const Times = {
  anytime: {
    title: "Any time",
  },
  morning: {
    title: "Morning",
  },
  midday: {
    title: "Mid-day",
  },
  evening: {
    title: "Evening",
  },
};

const emojiRegexPattern = emojiRegex();

const StackExpandedInner = React.memo(
  ({ handleShown, handleCheckout, history, match, location }) => {
    const context = useContext(MetaContext);
    const handleStackShown = () => {
      // setStackShown(!stackMode);
      // handleShown();
      history.push("/");
    };

    const [stackMode, setStackMode] = useState();

    const [stack, setStack] = useState([]);

    Array.prototype.diff2 = function (arr2) {
      this.sort();
      arr2.sort();
      return JSON.stringify(this) === JSON.stringify(arr2) ? true : false;
    };

    const [dropped, setDropped] = useState(false);

    useEffect(() => {
      // console.log(
      //   "context.handles.getStack().diff2(stack) = ",
      //   context.handles.getStack().diff2(stack)
      // );
      if (
        (!stack.length || !context.handles.getStack().diff2(stack)) &&
        !dropped
      ) {
        setStack(initialSortStack(context.handles.getStack()));
      }
      if (stack.length && !context.handles.getStack().diff2(stack)) {
      }
    }, [context, dropped]);

    useEffect(() => {
      if (dropped) {
        context.handles.setStack(stack);
        setDropped(false);
        stackUrl();
      }
    }, [stack, dropped]);

    const initialSortStack = (arr) => {
      let ord = ["anytime", "morning", "midday", "evening"];

      arr = arr.sort(
        (a, b) => ord.indexOf(a["useWhen"]) - ord.indexOf(b["useWhen"])
      );
      arr.forEach((itm, i) => (itm["order"] = i));
      return arr;
    };

    useEffect(() => {
      if (context && location && location.pathname.includes("stack")) {
        setStackMode(true);
      } else {
        setStackMode(false);
      }

      if (
        context &&
        context["data"]["supplements"] &&
        context["data"]["supplements"].length &&
        location &&
        location.pathname.includes("import") &&
        context.handles.getAllStacks().length
      ) {
        context.handles.createStack(getStackFromUrl(true));
        history.push("/stack");
      }
    }, [context, location]);

    const stackUrl = () => {
      history.push(codeHashToCopy(codeStackToHash()));
    };

    const [title, setTitle] = useState();

    const filterByTime = (arr, tm) =>
      arr.filter((oneItem) => oneItem["useWhen"] === tm);

    const codeStackToHash = () => {
      // history.push(`#${stack.map((id, i) => `${getDataById(context, id)['code']}`)}`)
      return `#${context.handles.getStack("title")}:${[
        "anytime",
        "morning",
        "midday",
        "evening",
      ]
        .map((timeOfDay, i, arr) => {
          return `${
            filterByTime(context.handles.getStack(), timeOfDay).length
              ? `${timeOfDay}=`
              : ""
          }${filterByTime(context.handles.getStack(), timeOfDay)
            .map(
              (itm, i, arr2) =>
                `${getDataById(context, itm["id"])["code"]}${
                  arr2.length && i !== arr2.length - 1 ? "," : ""
                }`
            )
            .join("")}${
            filterByTime(context.handles.getStack(), timeOfDay).length &&
            i !== arr.length - 1
              ? ";"
              : ""
          }`;
        })
        .join("")}`;
    };

    const getStackFromUrl = (what) => {
      let title = location["hash"].split(":")[0].split("#")[1];

      title = decodeURIComponent(title);
      // title = location['hash'].split(':')[0].split('#')[1].replace(/%20/g," ").replace(/-/g," ");
      title = title.replace(/%20/g, " ").replace(/-/g, " ");
      title = title.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "");
      // title = `${title}`

      setTitle(title);
      let stackCodesPerTime = location["hash"].split(":")[1].split(";");

      let stack = [];



      stackCodesPerTime.forEach((oneTime) => {
        console.log('oneTime = ', oneTime);
        if (oneTime) oneTime
          .split("=")[1]
          .split(",")
          .forEach((oneCode) => {
            stack.push({
              id: getDataByCode(context, oneCode)["id"],
              useWhen: oneTime.split("=")[0],
            });
          })}
      );

      return {
        title: title,
        stack: stack,
      };
    };



    const { addToast } = useToasts();

    function onDragEnd(result) {
      if (!result.destination) {
        return;
      }
      if (
        result.source.droppableId === result.destination.droppableId &&
        result.destination.index === result.source.index
      ) {
        return;
      }

      console.log("result.destination.index = ", result.destination.index);
      // context.handles.setStack(order)

      const findAbsIndex = (relIndex, timeOfDay) => {
        let indexArr = [];
        stack.forEach((itm, i) => {
          if (itm["useWhen"] === timeOfDay) {
            indexArr.push(i);
          }
        });
        return indexArr[relIndex];
      };

      setStack(
        reorder(
          stack,
          result.source.index,
          result.destination.index,
          // findAbsIndex(result.destination.index, result.destination.droppableId),
          result.draggableId,
          result.destination.droppableId
        )
      );
      setDropped(true);

      // setStack(stack)
      // setState({ quotes });
    }

    const checkLength = (arr, timeOfDay) => Boolean(arr.filter((item) => item["useWhen"] === timeOfDay).length)

    const reorder = (list, startIndex, endIndex, draggableId, droppableId) => {
      let newStack = JSON.parse(JSON.stringify(list));
      newStack.forEach((itm, i) => {
        console.log(
          "> ",
          i,
          "-",
          getDataById(context, itm["id"])["name"],
          "-",
          itm["useWhen"]
        );
      });
      // const result = Array.from(list);

      let itemIndex = newStack.findIndex((itm) => itm["id"] === draggableId);
      console.log("droppableId = ", droppableId);
      newStack[itemIndex]["useWhen"] = droppableId;

      const [removed] = newStack.splice(startIndex, 1);
      newStack.splice(endIndex, 0, removed);

      newStack = initialSortStack(newStack);

      // newStack.forEach((itm, i) => {
      //   itm['order'] = i;
      //   itm['name'] = getDataById(context, itm['id'])['name'];

      //   console.log(i, '-', getDataById(context, itm['id'])['name'], '-', itm['useWhen']);
      // })

      return newStack;
    };

    useEffect(() => {
      // debugger
      if (context && location && stackMode) {
        stackUrl();
      }
      // if (stackMode && history && context) stackUrl(context.handles.getStack())
    }, [stackMode, history, context]);

    return (
      <>
        {/* <CSSz
          stackMode={context && stackMode}
          onClick={() => handleStackShown()}
        /> */}


        {/* <CSSstackModeBg active={true}> */}
          {/* {stackMode && ( */}
            <CSSstackInside>

            {!Boolean(context.handles.getStack().length) && <Preloader0><Preloader width={80} height={80}/></Preloader0>}


             {Boolean(context.handles.getStack().length) && <CSSstackLayout>
                <Line lg>
                  <DragDropContext onDragEnd={onDragEnd}>
                    {["anytime", "morning", "midday", "evening"].map(
                      (timeOfDay, i) => (
                        <CSSstackLayoutDay key={`${uniqid()}`}>
                          {checkLength(stack, timeOfDay) && <h3>{Times[timeOfDay]["title"]}</h3>}
                          {!checkLength(stack, timeOfDay) && <Text color='#ccc'><h4>{Times[timeOfDay]["title"]}</h4></Text>}

                          <Droppable droppableId={`${timeOfDay}`} id={i}>
                            {(provided, snapshot) => (
                              <CSSstackLayoutTime empty={!checkLength(stack, timeOfDay)}>
                                <CSSstackGrid
                                  ref={provided.innerRef}
                                  {...provided.droppableProps}
                                >
                                  {stack
                                    .filter((item) => item["useWhen"] === timeOfDay)
                                    .map((stackItem, i) => {
                                      let id = stackItem["id"];
                                      let item = getDataById(context, id);
                                      return (
                                        <Draggable
                                          id={stackItem["order"]}
                                          index={stackItem["order"]}
                                          key={`product_stack_${item["name"]}}`}
                                          draggableId={`${id}`}
                                          handle=".handle"
                                        >
                                          {(provided, snapshot) => (
                                            <CSSdraggableProduct
                                              ref={provided.innerRef}
                                              // key={`product_stack_${item["name"]}}`}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                            >
                                              <Product
                                                // ref={provided.innerRef}
                                                order={stackItem["order"] + 1}
                                                // key={`product_stack_${item["name"]}}`}
                                                appearance="stackExpanded"
                                                active={context[
                                                  "handles"
                                                ].checkIfInStack(item["id"])}
                                                handle={() =>
                                                  context[
                                                    "handles"
                                                  ].handleStack(item["id"])
                                                }
                                                data={item}
                                              />
                                            </CSSdraggableProduct>
                                          )}
                                        </Draggable>
                                      );
                                    })}
                                  {provided.placeholder}
                                </CSSstackGrid>
                              </CSSstackLayoutTime>
                            )}
                          </Droppable>
                        </CSSstackLayoutDay>
                      )
                    )}
                  </DragDropContext>
                </Line>

                <Line>
                  <Line xlg>
                    <StackInfo />
                  </Line>

                  <Line>
                    <AddToCart handleCheckout={handleCheckout}/>
                  </Line>
                </Line>
              </CSSstackLayout>

            }
            </CSSstackInside>
          {/* )} */}
        {/* </CSSstackModeBg> */}
      </>
    );
  }
);

const CSScloseStack = styled.div`
  @media (max-width: 991px) {
    position: absolute;
    top: 0.8em;
    right: 2em;
  }
`;



const CSSz = styled.div`
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 150ms ease-in-out;
  /* border: 1px solid black; */
  box-shadow: inset 0px 0px 0px -10px rgba(0, 0, 0, 0.7);
  ${({ stackMode }) =>
    stackMode &&
    css`
      pointer-events: auto;
      opacity: 1;
      background-color: var(--main-text-lighter-color);
      /* border: 20px solid black; */
      box-shadow: inset 0px 0px 40px 10px rgba(0, 0, 0, 0.2);
    `}
`;

export const CSSstackModeBg = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: calc(100vw - 340px);
  /* width: 340px; */
  right: 0;
  bottom: 0;
  box-shadow: 0px 1px 40px -20px rgba(0, 0, 0, 0);
  transition: ${({active}) => active ? 'all 350ms ease-out' : 'none'};
  z-index: -1;
  background-color: var(--main-bg-lighter-color);
  @media (max-width: 1300px) {
    width: 300px;
    left: calc(100vw - 280px);
    ${({ active }) =>
      active &&
      css`
        left: 40px;
      `}
  }
  ${({ active }) =>
    active &&
    css`
      opacity: 1;
      background-color: var(--main-bg-lighter-color);
      /* width: 100vw; */
      right: 0px;
      left: 40px;
      z-index: 10;
    `}

  @media (max-width: 991px) {
    background-color: white;
    box-shadow: 0px 8px 20px -10px rgba(0, 0, 0, 1);
    border-radius: 1em;
    position: absolute;
    left: 1em;
    right: 1em;
    /* top: 0em; */
    ${({ active }) =>
      active &&
      css`
        width: auto;
        top: 0.2em;
        left: 0.2em;
        right: 0.2em;
        bottom: 0.2em;
        border-radius: 1em;
        position: relative;
        /* position: absolute; */
        /* position: fixed; */
        opacity: 1;
        background-color: var(--main-bg-color);
      `}
  }
`;

const CSSstackInside = styled.div`
  padding: 1em 8em 0 8em;
  position: relative;
  z-index: 101;
  overflow-y: auto;
  height: 100vh;
  @media (max-width: 991px) {
    padding: 0em 2em 0 2em;
  }
`;

const CSSstackLayout = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-column-gap: 3em;
  align-items: start;
  @media (max-width: 991px) {
    grid-template-columns: 1fr;
  }
`;

const CSSstackLayoutDay = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  grid-column-gap: 2em;
  grid-row-gap: 2em;
  margin-bottom: 2em;
  @media (max-width: 991px) {
    grid-template-columns: 1fr;
    margin-bottom: 2em;
  }
`;

const CSSstackLayoutTime = styled.div`
  display: grid;
  background: ${({empty}) => empty ? 'var(--main-bg-lighter-color)' : 'var(--main-bg-color)'};
  min-height: 1.2em;
  border-radius: 0.5em;
  padding: 0.2em;
  grid-template-columns: 1fr;
  grid-column-gap: 2em;
  grid-row-gap: 2em;
  /* margin-bottom: 4em; */
  /* grid-row-gap: 4em; */
`;

export const CSSstackGrid = styled.div`
  /* box-shadow: 0px 1px 8px -6px var(--main-text-lighter-color); */
  /* background: var(--main-bg-lighter-color); */
  border-radius: 0.4em;
  overflow: hidden;
  width: 100%;
  /* display: grid; */
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: start;
  grid-column-gap: 0.4em;
  grid-row-gap: 1em;
  grid-template-columns: 1fr;
  /* grid-template-rows: auto; */
  /* grid-template-columns: ${({ width }) =>
    width
      ? `repeat(auto-fit, minmax(${width}px, ${width}px))`
      : `repeat(auto-fit, minmax(220px, 238px))`};
  @media (max-width: 991px) {
    grid-template-columns: ${({ width }) =>
    width
      ? `repeat(auto-fit, minmax(140px, 1fr))`
      : `repeat(auto-fit, minmax(140px, 48%))`};
  } */
`;

const CSSdraggableProduct = styled.div`
  background: var(--main-bg-lighter-color);
  box-shadow: 0px 1px 8px -6px var(--main-text-lighter-color);
  border-radius: 0.4em;
`;

export const StackExpanded = withRouter(StackExpandedInner);
